export default __webpack_public_path__ + "static/media/GPA_55thlogo2.8aecff4e.png";